import { doc, setDoc, arrayUnion } from "firebase/firestore";
import { auth, db } from "../../../firebase/FirebaseCredential";

const saveTokenToBenchProfile = async (token: string, userId: string, companyId: string) => {

  const user = auth.currentUser;
  if (!user) return;

  try {
    // Store token as array so both mobile + web tokens coexist.
    // arrayUnion ensures we never add duplicates and never overwrite mobile token.
    const benchProfileDocRef = doc(db, "benchprofile", userId);

    await setDoc(
      benchProfileDocRef,
      {
        admin_fcm_token: arrayUnion(token),
      },
      { merge: true }
    );

    console.log("✅ admin_fcmtoken saved to benchprofile (array)");
  } catch (err) {
    console.error("❌ Error saving admin_fcmtoken to benchprofile:", err);
  }
};

export default saveTokenToBenchProfile;
